import { useState, useEffect } from "react";
import { IconMinus, IconPlus } from "@tabler/icons-react";
interface QuantitySelectorProps {
    value?: number;
    onChange?: (value: number) => void;
    min?: number;
    max?: number;
    disabled?: boolean;
    className?: string;
}
export function QuantitySelector({ value = 1, onChange, min = 1, max, disabled = false, className = "", }: QuantitySelectorProps) {
    const [quantity, setQuantity] = useState(value);
    // Sync internal state with prop value
    useEffect(() => {
        setQuantity(value);
    }, [value]);
    const handleDecrease = () => {
        const newValue = Math.max(min, quantity - 1);
        setQuantity(newValue);
        onChange?.(newValue);
    };
    const handleIncrease = () => {
        const newValue = max ? Math.min(max, quantity + 1) : quantity + 1;
        setQuantity(newValue);
        onChange?.(newValue);
    };
    return (<div className={`flex items-center border border-uiSecondary rounded-lg overflow-hidden ${className}`}>
      <button type="button" onClick={handleDecrease} disabled={disabled || quantity <= min} className="flex items-center justify-center w-10 h-10 hover:bg-uiSecondary transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <IconMinus size={20}/>
      </button>
      <div className="flex items-center justify-center w-12 h-10 bg-bgDefault border-x border-uiSecondary">
        <span className="text-textPrimary font-medium">{quantity}</span>
      </div>
      <button type="button" onClick={handleIncrease} disabled={disabled || (max !== undefined && quantity >= max)} className="flex items-center justify-center w-10 h-10 hover:bg-uiSecondary transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <IconPlus size={20}/>
      </button>
    </div>);
}
